import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Stack,
  Fade,
} from '@mui/material';
import {
  Spa,
  SelfImprovement,
  LocalFlorist,
  AutoAwesome,
  FavoriteBorder,
  Healing,
  FitnessCenter,
  Psychology,
} from '@mui/icons-material';

const services = [
  {
    icon: AutoAwesome,
    title: 'Personalised Flavours & Textures',
    description: 'Custom-crafted flavours and textures tailored to individual palates, ensuring every experience is enjoyable, balanced, and uniquely yours.',
  },
  {
    icon: Spa,
    title: 'Herb-Infused Wellness Formulations',
    description: 'Thoughtfully infused with ancient Ayurvedic herbs such as Shatavari, Shilajit, and other time-honoured ingredients, selected based on your personal wellness goals.',
  },
  {
    icon: FavoriteBorder,
    title: 'Clean & Conscious Nutrition Options',
    description: 'Gluten-free, sugar-free, and refined-sugar-free creations designed without compromising on taste, purity, or nutritional quality.',
  },

];

const ServicesSection = () => {
  return (
    <Box
      id="services"
      sx={{
        py: { xs: 8, md: 12 },
        background: 'linear-gradient(135deg, #F8F6F1 0%, #E8E3D8 50%, #F5F2EB 100%)',
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        <Fade in timeout={1000}>
          <Stack spacing={6}>
            {/* Section Header */}
            <Stack spacing={2} alignItems="center">
              <Typography
                variant="overline"
                sx={{
                  color: 'primary.main',
                  fontWeight: 600,
                  letterSpacing: '0.2em',
                }}
              >
                Offerings
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2rem', md: '3rem' },
                  fontWeight: 700,
                  textAlign: 'center',
                }}
              >
                Our Services
              </Typography>
              <Box
                sx={{
                  width: 60,
                  height: 3,
                  bgcolor: 'primary.main',
                  borderRadius: 2,
                }}
              />
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ textAlign: 'center', maxWidth: 800 }}
              >
                At Veda and Vine, we believe wellness should be personal. That’s why our offerings go
                beyond ready-made delicacies—we create thoughtfully customised laddoos tailored to your
                taste preferences and lifestyle needs.
              </Typography>

              <Typography
                variant="h4"
                color="text.primary"
                className='cardTopText'
                sx={{ textAlign: 'center', lineHeight: 1.1 }}
              >
                We work closely with our customers to:
              </Typography>

            </Stack>

            {/* Services Grid */}
            <Grid container spacing={3} className='grid-w mt-20'>
              {services.map((service, index) => {
                const IconComponent = service.icon;
                return (
                  <Grid item xs={12} sm={6} md={4} key={index} className='grid-cst'>
                    <Card
                      elevation={2}
                      sx={{
                        height: '100%',
                        borderRadius: 3,
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-8px)',
                          boxShadow: 6,
                        },
                      }}
                    >
                      <CardContent sx={{ p: 4 }}>
                        <Stack spacing={2} alignItems="center" textAlign="center">
                          <Box
                          className="icon-circle2"
                            sx={{
                              width: 80,
                              height: 80,
                              borderRadius: '50%',
                              bgcolor: 'primary.main',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              mb: 2,
                            }}
                          >
                            <IconComponent sx={{ color: 'white', fontSize: 40 }} />
                          </Box>
                          <Typography variant="h5" fontWeight={600} lineHeight={1.2}>
                            {service.title}
                          </Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                            {service.description}
                          </Typography>
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>

            <Grid container spacing={3} justifyContent="center" width="100%">
              <Typography
                variant="body2"
                color="text.secondary"
                className='cardFootSmall'
                sx={{ textAlign: 'center', marginBottom:'1rem', marginTop:'1rem', lineHeight: 1.8}}
              >
                Every creation is made using organic, responsibly sourced ingredients, prepared
                with care and precision. Whether you are seeking a nourishing everyday treat, a
                wellness-focused indulgence, or a thoughtful gift, we ensure each product reflects
                purity, balance, and customer satisfaction.
              </Typography>

              <Typography
                variant="h4"
                color="text.primary"
                className='cardFootText'
                sx={{ textAlign: 'center', lineHeight: 1.2}}
              >
                At Veda and Vine, your well-being guides every recipe.
              </Typography>

            </Grid>

          </Stack>

        </Fade>
      </Container>
    </Box>
  );
};

export default ServicesSection;
